module.exports = __webpack_public_path__ + "static/fintech_awards_logo-239130af45ec19dde7535e9178906c42.png";